import { FormattedMessage, useIntl } from "react-intl";
import InnerHeader from "../../component/shared/innerheader/InnerHeader.js";
import ContentLoading from "component/LoadingComponent/ContentLoading.js";
import MainDepartment from "component/shared/main-department/MainDepartment.jsx";
import AboutDepartment from "component/shared/about-department/AboutDepartment.jsx";
import HtmlView from "component/htmlView/html-view.js";
import { LabelLangString } from "component/LabelLang/label-lang.js";
import { useNationalCenterForm } from "./useNationalCenterForm";
import NationalCenterForm from "./components/NationalCenterForm";
import "./../subscribeForm/SubscribeForm.scss";

function NationalCenter() {
  const intl = useIntl();
  const {
    dir,
    currentLocale,
    register,
    errors,
    onSubmit,
    governorates,
    trainingPrograms,
    getDepartment,
    getServices,
    isLoading,
  } = useNationalCenterForm();

  return (
    <ContentLoading isLoading={isLoading}>
      <div className="national-center">
        <InnerHeader
          breadcrumb={[
            {
              title: intl.formatMessage({ id: "service-tools" }),
              clickClass: false,
            },
            {
              title: intl.formatMessage({ id: "national-center-services" }),
              clickClass: true,
            },
          ]}
          title={intl.formatMessage({ id: "national-center-title" })}
          route={"../servicestools"}
        />

        <div className="container py-5">
          <div className="row">
            <div className="col-lg-8">
              <div className="m__title">
                <h3>
                  <FormattedMessage id="national-center" />
                </h3>
              </div>

              <NationalCenterForm
                register={register}
                errors={errors}
                dir={dir}
                currentLocale={currentLocale}
                trainingPrograms={trainingPrograms}
                governorates={governorates}
                onSubmit={onSubmit}
              />
            </div>

            <div className="col-lg-4">
              <AboutDepartment
                id="about"
                txt={getServices?.data?.data?.about}
                translations={
                  getServices?.data?.data?.serviceAndToolTranslation
                }
              />
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-12 col-lg-8">
              <div className="service-content">
                {getServices?.data?.data?.content != null ? (
                  <HtmlView
                    html={LabelLangString({
                      id: "content",
                      currentLocale,
                      defaultValue: getServices?.data?.data?.content,
                      translations:
                        getServices?.data?.data?.serviceAndToolTranslation,
                    })}
                  />
                ) : (
                  <FormattedMessage id="data-not-found" />
                )}
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <MainDepartment getDepartment={getDepartment} />
            </div>
          </div>
        </div>
      </div>
    </ContentLoading>
  );
}

export default NationalCenter;
